// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getLaborRatesForRequestID} from '../../../claim/shared/repositories';
import {infoAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const readLaborRates = account =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborRatesForRequestID(account, true);

            const isShowInfoMessage = data.map(laborRate =>

                laborRate.rates.some(rate => rate.isRateDifferenceLarge === true)

            );

            if (isShowInfoMessage.some(isshowMessage => isshowMessage === true)) {

                infoAlertBar(translate('LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE'));

            }

            dispatch({
                data,
                type: actions.UPDATE_TCSM_LABOR_RATE_CHANGES_FOR_ACCOUNT
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/action-creators/get-labor-rate.js